import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import StepShell from "../components/StepShell";
import AyupathCard from "../components/AyupathCard";
import Field from "../components/Field";
import LocationAutocomplete from "../components/LocationAutocomplete";
import PrimaryButton from "../components/PrimaryButton";
import { useForm } from "../context/FormContext";
import useEnterToContinue from "../hooks/useEnterToContinue";

const TOTAL = 6;

export default function StepLocation() {
  const { formData, setFormData } = useForm();
  const navigate = useNavigate();
  const [touched, setTouched] = useState(false);

  const hasSelection = !!formData.locationData;

  const error = useMemo(() => {
    if (!touched) return "";
    if (!formData.location.trim()) return "Please enter your birth location.";
    if (formData.location.trim().length < 3) return "Location looks too short.";
    if (!hasSelection) return "Please select a location from the suggestions.";
    return "";
  }, [formData.location, touched, hasSelection]);

  const canContinue = hasSelection && formData.location.trim().length >= 3;

  useEnterToContinue(() => navigate("/focus"), canContinue);

  return (
    <StepShell step={4} totalSteps={TOTAL} title="Your next chapter">
      <AyupathCard>
        <div className="space-y-5">
          <div>
            <h2 className="text-2xl font-semibold text-gray-900">Where were you born?</h2>
            <p className="text-gray-600 mt-1">Start typing and select from the suggestions.</p>
          </div>

          <Field label="Birth location" error={error}>
            <LocationAutocomplete
              value={formData.location}
              selectedItem={formData.locationData}
              onChange={(text) =>
                setFormData({
                  ...formData,
                  location: text,
                  locationData: null,   // clear selection when user types
                })
              }
              onSelect={(item) => {
                const addr = item.raw?.address || {};
                setFormData({
                  ...formData,
                  location: item.displayName,
                  locationData: {
                    lat: item.lat,
                    lon: item.lon,
                    displayName: item.displayName,
                    placeId: item.placeId,
                    city: addr.suburb || addr.city || addr.town || addr.village || '',
                    region: addr.state || addr.province || addr.region || '',
                    country: addr.country || '',
                  },
                });
              }}
              onBlur={() => setTouched(true)}
              placeholder="e.g., Melbourne, Australia"
              autoFocus
            />
          </Field>

          <PrimaryButton disabled={!canContinue} onClick={() => navigate("/focus")}>
            Next
          </PrimaryButton>
        </div>
      </AyupathCard>
    </StepShell>
  );
}
